namespace Matrix.Data {
    export class SecurityMatchRulesetRuleColumns {
        static columnsKey = 'Data.SecurityMatchRulesetRule';
    }
}
